import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * Gp icon
 *
 * @category Medical
 */
const Gp = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <g clip-path="url(#gp-a)">
          <path
            fill="currentColor"
            d="M16.389 3.06c.43.076.628.78 1.017.976 1.522.376 2.817 1.094 3.09 2.761.2 1.395-.248 3.765-.316 5.277-.007 3.819-2.519 7.125-6.164 8.138-1.366.548-.93 2.162-.596 3.548 1.52 6.078 10.199 4.527 11.24-.506.314-1.888.176-4.138.149-6.007-.07-1.147-1.81-1.72-2.385-2.713-1.457-2.106.364-5.336 3.012-5.043 2.415.072 3.837 3.135 2.462 5.043-.395.634-1.13 1.086-1.518 1.71-.46.797-.354 1.294-.407 2.355-.04 1.487.082 3.354-.185 4.655-1.341 6.536-9.952 7.589-12.902 2.477-.979-1.44-.939-3.753-1.734-4.989-.344-.4-.924-.59-1.42-.776-3.343-1.054-5.414-4.361-5.434-7.836-.073-1.839-.482-3.67-.279-5.29.21-1.36 1.419-2.458 2.789-2.615.789-.048 1.217-.49 1.705-1.013.434-.253.804.671.791 1.54.064.985.135 2.357-1.075 1.342-.642-.73-1.74-.663-2.499-.296-1.261.611-.229 3.874-.229 6.332.512 8.546 11.15 9.79 13.198 1.662.281-1.433.348-3.464.518-5.003.087-1.172.27-1.712-.394-2.628-.253-.333-1.01-.74-1.249-.649-.687.12-.58.657-1.126.83-.706.253-.809-1.013-.763-1.59.012-.568-.04-1.547.563-1.672l.14.008zm8.756 7.656a2.08 2.08 0 0 0-2.07 2.067 2.07 2.07 0 0 0 2.056 2.064 2.07 2.07 0 0 0 2.064-2.056c-.004-.972-.815-2.075-2.05-2.075"
          />
        </g>
        <defs>
          <clipPath id="gp-a">
            <path fill="currentColor" d="M0 0h32v32H0z" />
          </clipPath>
        </defs>
      </svg>
    );
  }
);

Gp.displayName = 'Gp';

export { Gp };
